import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AgGridComponentFrameworkComponent} from "../../../../../shared/components/ag-grid/ag-grid-component-framework/ag-grid-component-framework.component";
import {CellSourceComponent} from "../../../../../shared/components/cell-source/cell-source.component";
import {AgGridTemplateFrameworkComponent} from "../../../../../shared/components/ag-grid/ag-grid-template-framework/ag-grid-template-framework.component";
import {TranslateService} from "@ngx-translate/core";
import {AppService} from "../../../../../shared/services/app.service";
import {ManageDimensionsGroupDialogComponent} from "../manage-dimensions-group-dialog/manage-dimensions-group-dialog.component";
import {DialogConfirmComponent} from "../../../../../shared/components/dialog/dialog-confirm/dialog-confirm.component";
import {ActivatedRoute} from "@angular/router";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../../shared/store/store";
import {Observable} from "rxjs";
import {dialogOpen} from "../../../../../shared/store/dialog/dialog.actions";
import {
  selectDataSetDimensionsGroupComponentObjects,
  selectDataSetDimensionsGroupsLoading
} from '../../../../../shared/store/dataSetDimensionsGroups/dataSetDimensionsGroups.selectors';
import {
  DatasetDimensionsGroupComponentObject,
  DatasetDimensionsGroupComponentObjects
} from '../../../../../shared/classes/dataset-dimensions-group-component-object';
import {
  deleteDataSetDimensionsGroup,
  deleteDataSetDimensionsGroupSuccess
} from '../../../../../shared/store/dataSetDimensionsGroups/dataSetDimensionsGroups.actions';
import {Serializer} from '../../../../../shared/interfaces/serializer';
import {DataSetDimensionsGroup} from '../../../../../shared/interfaces/dimensions';

@Component({
  selector: 'app-dimensions-category-table',
  templateUrl: './dimensions-category-table.component.html',
  styleUrls: ['./dimensions-category-table.component.scss']
})
export class DimensionsCategoryTableComponent implements OnInit {
  @ViewChild('name') private readonly _nameTemplate: TemplateRef<any>;
  @ViewChild('count') private readonly _countTemplate: TemplateRef<any>;
  @ViewChild('actions') private readonly _actionTemplate: TemplateRef<any>;

  public readonly groupsColumnDefs: Array<any> = [
    {
      minWidth: 200,
      sortable: true,
      filter: true,
      lockPosition: true,
      valueGetter: params => params.data.payload.attributes.name,
      headerValueGetter: _ => this._translateS.instant('settings.category'),
      cellRendererFramework: AgGridTemplateFrameworkComponent,
      cellRendererParams: _ => {
        return {
          ngTemplate: this._nameTemplate
        };
      }
    },
    {
      minWidth: 200,
      sortable: true,
      filter: true,
      lockPosition: true,
      valueGetter: params => params.data.payload.attributes.dimensions_number,
      headerValueGetter: _ => {
        return this._translateS.instant('settings.dimensions');
      },
      cellRendererFramework: AgGridTemplateFrameworkComponent,
      cellRendererParams: _ => {
        return {
          ngTemplate: this._countTemplate
        };
      }
    },
    {
      minWidth: 200,
      sortable: false,
      filter: false,
      lockPosition: true,
      suppressMenu: true,
      cellRendererFramework: AgGridTemplateFrameworkComponent,
      cellRendererParams: _ => {
        return {
          ngTemplate: this._actionTemplate
        };
      }
    }
  ];

  public readonly defaultColDef: any = {
    resizable: true,
    suppressNavigable: true,
    suppressCellSelection: true,
    menuTabs: ['filterMenuTab'],
    filterParams: {
      buttons: ['reset']
    }
  };

  public readonly categories$: Observable<DatasetDimensionsGroupComponentObjects> = this._store.select(selectDataSetDimensionsGroupComponentObjects);
  public readonly loading$: Observable<boolean> = this._store.select(selectDataSetDimensionsGroupsLoading);

  constructor(
    private readonly _translateS: TranslateService,
    public readonly appS: AppService,
    public  readonly route: ActivatedRoute,
    private readonly _store: Store<AppState>
  ) { }

  ngOnInit(): void {
  }

  public onUpdate(category: DatasetDimensionsGroupComponentObject): void {
    this._store.dispatch(dialogOpen({
      component: ManageDimensionsGroupDialogComponent,
      config: {
        width: '600px',
        height: 'auto',
      },
      data: {
        category: category.payload
      }
    }));
  }

  public onDelete(group: DatasetDimensionsGroupComponentObject): void {
    this._store.dispatch(dialogOpen({
      component: DialogConfirmComponent,
      config: {
        width: '500px',
        height: 'auto',
      },
      data: {
        title: 'dimensions.delete_dimensions_group_title',
        message: 'dimensions.delete_dimensions_groups_message',
        type: 'delete',
        item: group.payload,
        startActions: [deleteDataSetDimensionsGroup],
        successActions: [deleteDataSetDimensionsGroupSuccess],
        onSubmit: () => {
          this._store.dispatch(deleteDataSetDimensionsGroup({
            group: group.payload as Serializer<DataSetDimensionsGroup>
          }))
        }
      }
    }));
  }

}
